import(/* webpackMode: "eager" */ "/home/ubuntu/download_staging/6a1a5a498be93c00142ba954_1780141264817/rideos/src/app/passenger-app/page.tsx");
